import $ from "jquery";

export function setMenuBarSize(){
    var subemnu_height = $(".menu-item-has-children").find('.sub-menu').height();
    $('.menu-bar').css({
        "height" : subemnu_height + 1,
    })
};
